module.exports = __webpack_public_path__ + "img/80103001.a9292c9e.png";